import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom }: Theme) => ({
  root: {
    color: custom.status.success.main,
    zIndex: 1,
  },
}));
